module.exports = __webpack_public_path__ + "media/Video 83.d1fb59a0.mp4";